<template>
    <div class="tab-clinic-location">
        <div class="blockcont">
            <div class="smalltitle">Contact Information
            </div>

            <ul class="itemlist locationlist" v-for="item in contactData">
                <li>
                    <div class="row">
                        <div class="col-xs-5">
                            <strong class="address">{{item.name}}</strong><br>
                            <em>{{item.streetname}}, {{item.city}} {{item.state}} {{item.zip}}</em>
                        </div>
                        <div class="col-xs-3"></div>
                        <div class="col-xs-2" style="text-align: right">
                            <span style="display: inline-block;" class="phone">{{item.phone | formatPhone}}</span>
                        </div>
                        <div class="col-xs-2 itemaction " >

                        </div>
                    </div>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
import CommonMixin from './../../../../mixins/general/CommonMixin.vue'
import config from '../../../../config'
import httpClient from '../../../../client'

export default {
  name: 'TabContactInfo',
  components: {},
  props: {
    userInfo: {}
  },
  mixins: [CommonMixin],
  data () {
    return {
      contactData: []
    }
  },
  computed: {
    disabledForm () {
      return true
    }
  },
  watch: {},
  updated () {
  },
  mounted () {
    this.getContactInfo()
  },
  beforeDestroy () {
  },
  methods: {
    async getContactInfo () {
      try {
        let response = await httpClient.get('/users/contact-info/' + this.userInfo.id)
        if (response.data.s === 200) {
          this.contactData = response.data.data.contactInfos
        } else {
          this.alertError(response.data.msg)
        }
      } catch (e) {
        this.alertError(e.message)
      }
    }
  }
}
</script>
<style scoped="">

</style>
